<template>
    <div class="printPage"
        v-loading="loading"
        element-loading-text="加载数据中">
        <div class="print-head" id="print-head">
            银联商务车安堡对账表
        </div>
        <div class="print" id="print">
            
            <div class="print-body">
                <div class="print-body-subtitle">
                    <div>
                        公司名称：<span class="underline">{{company_name}}</span>
                    </div>
                    <div>
                        对账日期：<span class="underline">{{params.query_columns.start_time}}</span>至<span class="underline">{{params.query_columns.end_time}}</span>
                    </div>
                </div>
                <div class="print-body-main">
                    <el-table :data="printData" style="width: 100%">
                        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
                        <el-table-column label="桩群名称" prop="pile_group_name"></el-table-column>
                        <el-table-column label="桩群地址" prop="pile_group_addrs"></el-table-column>
                        <el-table-column label="电桩数量" prop="pile_counts" align="center" width="100"></el-table-column>
                        <el-table-column label="总电量(kWh)" prop="p_power" align="center" width="150"></el-table-column>
                        <el-table-column label="结算单价" prop="fee_val" align="center" width="150"></el-table-column>
                        <el-table-column label="结算金额" prop="fee" align="center" width="150"></el-table-column>
                    </el-table>
                </div>
                <div class="print-body-foot">
                    <div>审核人（签字）：</div>
                    <div>打印人（签字）：</div>
                    <div>打印日期：<span>{{currentTime()}}</span></div>
                </div>
            </div>
        </div>

        <el-button class="printBtn" type="primary" @click="print">打印</el-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            company_name: '',
            params: {
                page: 1,
                size: 100000,
                query_columns: {
                    cid: '',
                    pg_id: '',
                    company_name: '',
                    company_mobile: '',
                    start_time: '',
                    end_time: '',
                }
            },
            printData: []
        }
    },
    created() {
        this.params.query_columns.cid = this.$route.query.cid;
        this.params.query_columns.start_time = this.$route.query.start;
        this.params.query_columns.end_time = this.$route.query.end;
        this.company_name = this.$route.query.name;
        this.getPrintData();

        document.body.style.width="1200px";
        document.body.style.margin="0 auto";
        document.getElementsByTagName('html')[0].style.backgroundColor = '#fff';
    },
    methods: {
        getPrintData(){
            this.$http.post(this.common.admin + "/api/reconciliationListGp", this.params).then((res) => {
                if (res.code === 200) {
                    this.printData = res.data.list;
                } else {
                    return this.$message.error(res.msg);
                }
            });
        },
        currentTime(){
            var time = new Date();
            var year = time.getFullYear();
            var month = time.getMonth()+1;
            var day = time.getDate();
            return year+'-'+(month<10?'0'+month:month)+'-'+(day<10?'0'+day:day);
        },
        print(){
            this.$print({
                printable: 'print',
                type: 'html',
                header: '银联商务车安堡对账表',
                headerStyle: 'text-align: center;',
                maxWidth: '100%',
                style: 'max-width: 1200px;margin:0 auto;',
                targetStyles: ['*'], // 打印内容使用所有HTML样式，没有设置这个属性/值，设置分页打印没有效果
            })
        }
    },
}
</script>
<style lang="less" scoped>
    .printPage{
        height: 100%;
        background-color: #fff;
        position: relative;

        .printBtn{
            position: absolute;
            bottom: 100px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .print-head{
        text-align: center;
        font-size: 24px;
        padding: 15px 0;
        color: #161616;
    }
    .print{
        margin: 0 auto;
        max-width: 1200px;
        color: #161616;
        /deep/.el-table{
            font-size: 16px;
            border-color: #161616;
            
        }
        /deep/.el-table td.el-table__cell{
            border-color: #161616;
        }
        /deep/.el-table thead th.el-table__cell.is-leaf,
        /deep/.el-table tbody tr:last-of-type td.el-table__cell{
            border-bottom: 2px solid #161616;
        }
        // /deep/.el-table tbody tr:last-of-type td.el-table__cell{
        //     border-bottom: none;
        // }
        // /deep/.el-table thead th.el-table__cell.is-leaf{
        //     border-bottom: 2px solid #161616;
        // }
        // /deep/.el-table--border::after,
        // /deep/.el-table--group::after,
        /deep/.el-table::before{
            background-color: #161616;
        }

        

        .underline{
            padding: 0 15px;
            border-bottom: 1px solid #161616;
        }

        
        .print-body-subtitle{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0px;
            padding-right: 0;
            font-size: 16px;
        }

        .print-body-foot{
            display: flex;
            justify-content: flex-end;
            padding: 10px 0;
            padding-right: 20px;
            font-size: 16px;
            &>div{
                margin-left: 180px;

                &:first-of-type{
                    margin-left: 0;
                }
            }
        }
    }
    
</style>